/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Pricing_Save_PercentInputs */

const en_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`SAVE ${i?.percent}%`)
};

const es_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AHORRA ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "SAVE {percent}%" |
*
* @param {Pricing_Save_PercentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_save_percent = /** @type {((inputs: Pricing_Save_PercentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Save_PercentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_save_percent(inputs)
	return en_pricing_save_percent(inputs)
});